/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Cta_Start_MethodInputs */

const en_home_cta_start_method = /** @type {(inputs: Home_Cta_Start_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start The Method`)
};

const es_home_cta_start_method = /** @type {(inputs: Home_Cta_Start_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empezar el método`)
};

const de_home_cta_start_method = /** @type {(inputs: Home_Cta_Start_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starten Sie die Methode`)
};

const zh_home_cta_start_method = /** @type {(inputs: Home_Cta_Start_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开始方法`)
};

const ar_home_cta_start_method = /** @type {(inputs: Home_Cta_Start_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ابدأ المنهج`)
};

const fr_home_cta_start_method = /** @type {(inputs: Home_Cta_Start_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Démarrer la méthode`)
};

const vi_home_cta_start_method = /** @type {(inputs: Home_Cta_Start_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bắt đầu phương pháp`)
};

const sw_home_cta_start_method = /** @type {(inputs: Home_Cta_Start_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anza Mbinu`)
};

const th_home_cta_start_method = /** @type {(inputs: Home_Cta_Start_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เริ่มวิธีการ`)
};

const bs_home_cta_start_method = /** @type {(inputs: Home_Cta_Start_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Započni metodu`)
};

const ja_home_cta_start_method = /** @type {(inputs: Home_Cta_Start_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`方法を始める`)
};

const ko_home_cta_start_method = /** @type {(inputs: Home_Cta_Start_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`방법 시작`)
};

const pt_home_cta_start_method = /** @type {(inputs: Home_Cta_Start_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar o Método`)
};

const it_home_cta_start_method = /** @type {(inputs: Home_Cta_Start_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniziare il metodo`)
};

const sv_home_cta_start_method = /** @type {(inputs: Home_Cta_Start_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starta metoden`)
};

const nl_home_cta_start_method = /** @type {(inputs: Home_Cta_Start_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De methode starten`)
};

const da_home_cta_start_method = /** @type {(inputs: Home_Cta_Start_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start Metoden`)
};

const nb_home_cta_start_method = /** @type {(inputs: Home_Cta_Start_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start metoden`)
};

const fi_home_cta_start_method = /** @type {(inputs: Home_Cta_Start_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Käynnistä menetelmä`)
};

const pl_home_cta_start_method = /** @type {(inputs: Home_Cta_Start_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uruchom metodę`)
};

const ru_home_cta_start_method = /** @type {(inputs: Home_Cta_Start_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Начните метод`)
};

const tr_home_cta_start_method = /** @type {(inputs: Home_Cta_Start_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yöntemi Başlayın`)
};

const hi_home_cta_start_method = /** @type {(inputs: Home_Cta_Start_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विधि प्रारंभ करें`)
};

const id_home_cta_start_method = /** @type {(inputs: Home_Cta_Start_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mulai Metode`)
};

const ms_home_cta_start_method = /** @type {(inputs: Home_Cta_Start_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mulakan dengan Kaedah`)
};

const cs_home_cta_start_method = /** @type {(inputs: Home_Cta_Start_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spustit metodu`)
};

const el_home_cta_start_method = /** @type {(inputs: Home_Cta_Start_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Έναρξη της μεθόδου`)
};

const he_home_cta_start_method = /** @type {(inputs: Home_Cta_Start_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`התחילו את השיטה`)
};

const af_home_cta_start_method = /** @type {(inputs: Home_Cta_Start_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Begin die metode`)
};

const hu_home_cta_start_method = /** @type {(inputs: Home_Cta_Start_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A módszer elindítása`)
};

/**
* | output |
* | --- |
* | "Start The Method" |
*
* @param {Home_Cta_Start_MethodInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const home_cta_start_method = /** @type {((inputs?: Home_Cta_Start_MethodInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Cta_Start_MethodInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_cta_start_method(inputs)
	if (locale === "de") return de_home_cta_start_method(inputs)
	if (locale === "zh") return zh_home_cta_start_method(inputs)
	if (locale === "ar") return ar_home_cta_start_method(inputs)
	if (locale === "fr") return fr_home_cta_start_method(inputs)
	if (locale === "vi") return vi_home_cta_start_method(inputs)
	if (locale === "sw") return sw_home_cta_start_method(inputs)
	if (locale === "th") return th_home_cta_start_method(inputs)
	if (locale === "bs") return bs_home_cta_start_method(inputs)
	if (locale === "ja") return ja_home_cta_start_method(inputs)
	if (locale === "ko") return ko_home_cta_start_method(inputs)
	if (locale === "pt") return pt_home_cta_start_method(inputs)
	if (locale === "it") return it_home_cta_start_method(inputs)
	if (locale === "sv") return sv_home_cta_start_method(inputs)
	if (locale === "nl") return nl_home_cta_start_method(inputs)
	if (locale === "da") return da_home_cta_start_method(inputs)
	if (locale === "nb") return nb_home_cta_start_method(inputs)
	if (locale === "fi") return fi_home_cta_start_method(inputs)
	if (locale === "pl") return pl_home_cta_start_method(inputs)
	if (locale === "ru") return ru_home_cta_start_method(inputs)
	if (locale === "tr") return tr_home_cta_start_method(inputs)
	if (locale === "hi") return hi_home_cta_start_method(inputs)
	if (locale === "id") return id_home_cta_start_method(inputs)
	if (locale === "ms") return ms_home_cta_start_method(inputs)
	if (locale === "cs") return cs_home_cta_start_method(inputs)
	if (locale === "el") return el_home_cta_start_method(inputs)
	if (locale === "he") return he_home_cta_start_method(inputs)
	if (locale === "af") return af_home_cta_start_method(inputs)
	if (locale === "hu") return hu_home_cta_start_method(inputs)
	return en_home_cta_start_method(inputs)
});